import request from '@/utils/request';
import { AUTH_PUBLIC_REQUEST_CONFIG } from '@/api/auth';

/**
 * 查询 Privy App Signer 是否已授权
 * GET /liyuan-evm-pm/pm-chain/privy/app-signer-granted
 *
 * @param {{ privyWalletId: string, userAddress: string }} payload
 * @returns {Promise<{ granted: boolean, message?: string, status?: string }>}
 */
export function fetchPrivyAppSignerGranted(payload = {}) {
  const privyWalletId = String(payload.privyWalletId ?? '').trim();
  const userAddress = String(payload.userAddress ?? '').trim();

  if (!privyWalletId || !userAddress) {
    return Promise.reject(new Error('privyWalletId and userAddress are required'));
  }

  return request.get(
    '/liyuan-evm-pm/pm-chain/privy/app-signer-granted',
    {
      privyWalletId,
      userAddress,
    },
    AUTH_PUBLIC_REQUEST_CONFIG
  );
}
